import React from 'react';

import { ServiceTicketsTable } from './components/ServiceTicketsTable';
import { TicketCategories } from './components/TicketCategories';
import { TicketDistribution } from './components/TicketDistribution';
import styles from './index.module.scss';

const TicketRecordList = () => {
  return (
    <div className={styles.pageContent}>
      <ServiceTicketsTable />
      <TicketCategories />
      <TicketDistribution />
    </div>
  );
};

export default TicketRecordList;
